import { useEffect, useState } from 'react';
import { builder } from '@builder.io/react';
import BuilderPage from '../BuilderPage';
import UnauthenticatedLayout from '../../UnauthenticatedLayout';

// Initialize builder if not already done
if (!builder.apiKey) {
  builder.init(import.meta.env.REACT_APP_PUBLIC_BUILDER_KEY);
}

const RootRouteWrapper = () => {
  const [hasBuilderContent, setHasBuilderContent] = useState<boolean | null>(null);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const checkBuilderContent = async () => {
      // Check session storage first
      const cached = window.sessionStorage.getItem('rootHasBuilderContent');
      if (cached !== null) {
        setHasBuilderContent(cached === 'true');
        setIsChecking(false);
        return;
      }

      try {
        // Check if Builder.io has content for the root path
        const content = await builder.get('page', { url: '/' }).promise();
        const hasContent = !!content;
        setHasBuilderContent(hasContent);
        // Cache the result for this session
        window.sessionStorage.setItem('rootHasBuilderContent', String(hasContent));
      } catch (error) {
        // Log error but fall back gracefully
        setHasBuilderContent(false);
        window.sessionStorage.setItem('rootHasBuilderContent', 'false');
      } finally {
        setIsChecking(false);
      }
    };

    checkBuilderContent();
  }, []);

  // While checking, show the default layout to avoid flash of blank content
  if (isChecking) {
    return <UnauthenticatedLayout />;
  }

  // If Builder.io has content for root, render it
  if (hasBuilderContent) {
    return <BuilderPage />;
  }

  // Otherwise, fall back to the original UnauthenticatedLayout
  return <UnauthenticatedLayout />;
};

export default RootRouteWrapper;
